import * as Yup from "yup";

export const JsonExportFormValidation = () => Yup.object().shape({
  ctxId: Yup.string().required(),
})